var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs is-boxed"},[_c('ul',[_c('router-link',{attrs:{"to":{ name: 'client-kra-payments' },"active-class":"is-active","tag":"li"}},[_c('a',[_vm._v("Payments")])])],1)]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/kra/index.vue?vue&type=template&id=2ace311c&scoped=true
// module id = UYPY
// module chunks = 0